import React from 'react';
import PropTypes from 'prop-types';

import style from '../../../scss/components/form.module.scss';
import CategoryDropdown from '../../Framework/Components/Form/Dropdown/CategoryDropdown';

const ConcernGroup = ({
    legend = 'Skin and hair concerns',
    skinConcernsName = 'skin_concerns',
    hairProblemsName = 'hair_problems',
    ...fieldProps
}) => {
    return (
        <fieldset className={style.categoryHierarchyGroup}>
            <legend className={style.categoryHierarchyLegend}>{legend}</legend>

            <CategoryDropdown
                {...fieldProps}
                name={skinConcernsName}
                type="skinconcern"
                exclusiveOptionLabel="Nincs"
            />

            <CategoryDropdown
                {...fieldProps}
                name={hairProblemsName}
                type="hairproblem"
            />
        </fieldset>
    );
};

ConcernGroup.propTypes = {
    legend: PropTypes.string.isRequired,
    skinConcernsName: PropTypes.string.isRequired,
    hairProblemsName: PropTypes.string.isRequired,
};

export default ConcernGroup;
